/* Be’sycle atelier tracking — local consent-aware draft.
 * No personal data. No page_view. No purchase tracking.
 */
(function () {
  'use strict';

  var measurementId = 'G-4QJ78FGTWQ';
  var scriptId = 'besycle-ga4-atelier-gtag';

  function analyticsAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        window.Shopify.customerPrivacy &&
        typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        window.Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (_) {
      return false;
    }
  }

  function ensureSender() {
    if (!analyticsAllowed()) return false;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!document.getElementById(scriptId)) {
      var script = document.createElement('script');
      script.async = true;
      script.id = scriptId;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      document.head.appendChild(script);
      window.gtag('js', new Date());
      window.gtag('config', measurementId, { send_page_view: false });
    }
    return true;
  }

  function classify(anchor) {
    var href = anchor.getAttribute('href') || '';
    var lower = href.toLowerCase();
    var path;
    try { path = new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/'; }
    catch (_) { path = href.split('?')[0].split('#')[0].replace(/\/$/, '') || '/'; }
    if (lower.indexOf('tel:') === 0) {
      return { name: 'click_phone', destination: 'phone', delay: true };
    }
    if (lower.indexOf('google.com/maps') !== -1 || lower.indexOf('maps.google.com') !== -1 || lower.indexOf('maps.app.goo.gl') !== -1 || lower.indexOf('goo.gl/maps') !== -1) {
      return { name: 'click_google_maps', destination: 'google_maps', delay: true };
    }
    if (path === '/pages/contact') {
      return { name: 'click_contact', destination: 'contact' };
    }
    if (path === '/pages/reparation-trottinette-electrique-essonne' || path === '/collections/services-reparations') {
      return { name: 'click_repair_services', destination: 'repair_services' };
    }
    return null;
  }

  function track(info) {
    if (!ensureSender()) return false;
    window.gtag('event', info.name, {
      event_category: 'atelier',
      destination: info.destination,
      page_path: window.location.pathname,
      transport_type: 'beacon',
      event_callback: function () {},
      event_timeout: 900
    });
    return true;
  }

  document.addEventListener('visitorConsentCollected', ensureSender);
  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor || anchor.dataset.besycleTrackingBypass === 'true') return;
    var info = classify(anchor);
    if (!info || !track(info)) return;
    var target = anchor.getAttribute('target') || '';
    var modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
    if (!info.delay || target === '_blank' || modified) return;
    event.preventDefault();
    window.setTimeout(function () {
      anchor.dataset.besycleTrackingBypass = 'true';
      try { anchor.click(); }
      finally { delete anchor.dataset.besycleTrackingBypass; }
    }, 180);
  }, true);
  ensureSender();
  // The native banner does not itself expose the public consent API.
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' &&
      (!window.Shopify.customerPrivacy ||
       typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed !== 'function')) {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) ensureSender();
      });
    } catch (_) { /* Fail closed; links retain their native navigation. */ }
  }
})();
